import script from "./template.vue?vue&type=script&lang=ts&setup=true"
export * from "./template.vue?vue&type=script&lang=ts&setup=true"

import "./template.vue?vue&type=style&index=0&id=3ccf6bcd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccf6bcd"]])

export default __exports__